// src/pages/base/App.js
import React from "react";
import { useSelector } from "react-redux";
import RoutesComponent from "../../routes/Routes";
import ChatbotWidget from "../../components/global/Chatbot/ChatbotWidget"; // <-- new

function App() {
  const path = window.location.toString().split("/")[3];

  // determine login — prefer redux user, fallback to local token
  const authState = useSelector((s) => s?.AuthReducer || {});
  const reduxUser = authState?.user || authState?.userData || null;
  const localAccessToken = typeof window !== "undefined" ? localStorage.getItem("access_token") : null;
  const isLoggedIn = Boolean(reduxUser || localAccessToken);

  return (
    path !== "events" ? (
      <div className="App" style={{ marginTop: "55px" }}>
        <RoutesComponent />
        {isLoggedIn && <ChatbotWidget />}
      </div>
    ) : null
  );
}

export default App;